import { getDetailContent, getDetailIcon } from 'features/Weather/utils/cardDetails.utils';
import './assets/weatherCard.css';

/**
 * Displays a named group of weather details using the shared card styling.
 * headingLevel lets each page fit the title into its heading order without
 * changing the appearance or the paragraph titles used by existing forecasts.
 */
const WeatherCard = ({
  weatherObj,
  title,
  headerIcon,
  details = [],
  hideTitleAndIcon = false,
  headingLevel: Heading = 'p',
  emptyMessage,
}) => {
  return (
    <div className="d-flex flex-column w-100 h-100 gap-3 p-3 position-relative overflow-hidden border rounded-3 weather-card">
      {!hideTitleAndIcon && (
        <div className="d-flex align-items-center justify-content-between gap-3 pb-3 border-bottom position-relative z-1 weather-card-header">
          <Heading className="m-0 fw-bold lh-sm fs-6">{title}</Heading>
          {headerIcon && (
            <div className="d-inline-flex align-items-center justify-content-center flex-shrink-0 border rounded-3 weather-card-header-icon">
              {headerIcon}
            </div>
          )}
        </div>
      )}
      <div className="d-grid gap-2 position-relative z-1 weather-card-details">
        {!details.length && emptyMessage && <p className="m-0">{emptyMessage}</p>}
        {details.map((detail) => {
          const detailIcon = getDetailIcon(detail, weatherObj);

          return (
            <div
              className="d-flex align-items-center gap-2 p-2 border rounded-3 weather-card-detail"
              key={detail.id}
            >
              {detailIcon && (
                <span className="d-inline-flex align-items-center justify-content-center flex-shrink-0 border rounded-3 weather-card-detail-icon">
                  {detailIcon}
                </span>
              )}
              <div className="weather-card-detail-content">
                <span className="d-block text-uppercase fw-semibold lh-sm weather-card-detail-label">
                  {detail.label}
                </span>
                <div className="fw-bold lh-sm weather-card-detail-value">
                  {getDetailContent(detail, weatherObj)}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default WeatherCard;
